import { Link, useLocation } from 'react-router-dom'
import WLogo from './WLogo'

const navLinks = [
    { path: '/how-it-works', label: 'How It Works' },
    { path: '/features', label: 'Features' },
    { path: '/pricing', label: 'Pricing' },
    { path: '/about', label: 'About' },
]

export default function Header() {
    const location = useLocation()

    return (
        <header className="w-full py-6 px-8 lg:px-20">
            <nav className="flex justify-between items-center w-full max-w-7xl mx-auto">
                {/* Logo and Nav Links */}
                <div className="flex items-center gap-10">
                    {/* Logo */}
                    <Link to="/" className="flex items-center gap-3">
                        <WLogo className="w-8 h-8" />
                        <span className="text-xl font-semibold text-primary-color">Way2Will</span>
                    </Link>

                    {/* Navigation Links */}
                    <div className="hidden md:flex items-center gap-8">
                        {navLinks.map((link) => (
                            <Link
                                key={link.path}
                                to={link.path}
                                className={`text-base font-normal transition-colors hover:text-primary-color ${location.pathname === link.path
                                    ? 'text-primary-color'
                                    : 'text-secondary-color'
                                    }`}
                            >
                                {link.label}
                            </Link>
                        ))}
                    </div>
                </div>

                {/* CTA Button */}
                <div className="flex items-center">
                    <Link
                        to="/signup"
                        className="btn-primary flex items-center px-6 py-3 rounded-full font-semibold whitespace-nowrap"
                    >
                        Start Free Trial
                    </Link>
                </div>
            </nav>
        </header>
    )
}
